import { Injectable, inject } from '@angular/core';
import { ApiDependencyProviderService, HttpParams } from '@web/common';
import { map, Observable } from 'rxjs';
import { PublicCosmeticDetailsResponse } from '../responses/public-cosmetic-details.response';

@Injectable({
  providedIn: 'root',
})
export class PublicCosmeticApiService {
  private readonly provider = inject(ApiDependencyProviderService);

  /* prettier-ignore */
  public fetchDetailsBySlug(
    slug: string,
    cacheable = false,
  ): Observable<PublicCosmeticDetailsResponse> {
    const path = `cosmetic/${HttpParams.Slug}`;
    const url = this.provider.httpUrlFactory.complex((builder) =>
      builder
        .host(this.hostUrl())
        .path(path)
        .params({ [HttpParams.Slug]: slug })
        .build(),
    );
    const context = this.provider.httpContextBuilder
      .skipByAuthTokenInterceptor()
      .skipByLoadingInterceptor()
      .withOptionalCacheInterceptor(() => cacheable)
      .build();

    return this.provider.http
      .get(url, { context })
      .pipe(
        map(this.provider.httpHelper.bodyToResponse(PublicCosmeticDetailsResponse)),
      );
  }

  private hostUrl(): string {
    return this.provider.environment.ApiHostUrl.Shop;
  }
}
